import React from 'react';

const ResultsTable = ({ result }) => {
  const harmonicLabels = [
    "Basic Frequency",
    "Second Harmonic",
    "Third Harmonic",
    "Fourth Harmonic",
    "Fifth Harmonic",
    "Sixth Harmonic",
    "Seventh Harmonic",
    "Eighth Harmonic",
    "Ninth Harmonic"
  ];

  // Extract harmonics data from either new API format or legacy format
  const harmonics = result.harmonics || [];
  const harmonicFreqs = result.harmonicFreqs || harmonics.map(h => h.frequency) || [];
  const harmonicDBs = result.harmonicDBs || harmonics.map(h => h.db_level) || [];
  

  return (
    <div className="space-y-6">
      {/* Harmonic Analysis Table */}
      <div className="bg-gray-900 rounded-lg overflow-hidden border border-gray-800">
        <div className="overflow-x-auto">
          <table className="w-full border-collapse">
            <thead>
              <tr className="bg-gray-800">
                <th className="px-4 py-2 text-left font-semibold text-gray-300 border border-gray-700"></th>
                <th className="px-4 py-2 text-center font-semibold text-gray-300 border border-gray-700">Frequency(Hz)</th>
                <th className="px-4 py-2 text-center font-semibold text-gray-300 border border-gray-700">Energy(dB)</th>
              </tr>
            </thead>
            <tbody>
              {harmonicLabels.map((label, i) => {
                // Get harmonic data from API response
                let frequency = 0;
                let dbLevel = 0;
                
                if (result.harmonics && result.harmonics[i]) {
                  frequency = result.harmonics[i].frequency || 0;
                  dbLevel = result.harmonics[i].db_level || 0;
                } else if (result.harmonicFreqs && result.harmonicDBs) {
                  frequency = result.harmonicFreqs[i] || 0;
                  dbLevel = result.harmonicDBs[i] || 0;
                } else if (harmonicFreqs[i] && harmonicDBs[i]) {
                  frequency = harmonicFreqs[i] || 0;
                  dbLevel = harmonicDBs[i] || 0;
                }

                return (
                  <tr key={`harmonic-${i}`} className="hover:bg-gray-800">
                    <td className="px-4 py-2 text-sm font-medium text-gray-300 border border-gray-700">
                      {label}
                    </td>
                    <td className="px-4 py-2 text-sm text-gray-400 font-mono text-center border border-gray-700">
                      {frequency > 0 ? Math.round(frequency) : ""}
                    </td>
                    <td className="px-4 py-2 text-sm text-gray-400 font-mono text-center border border-gray-700">
                      {dbLevel !== 0 ? dbLevel.toFixed(1) : ""}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>

      {/* Statistics & Prediction Table */}
      <div className="bg-gray-900 rounded-lg overflow-hidden border border-gray-800">
        <div className="bg-green-900/30 px-4 py-3 border-b border-green-800">
          <h4 className="text-lg font-semibold text-green-400">📈 Statistics & Prediction</h4>
        </div>
        <div className="overflow-x-auto">
          <table className="w-full">
            <tbody className="divide-y divide-gray-800">
              <tr className="hover:bg-gray-800">
                <td className="px-4 py-3 text-sm font-medium text-gray-300">Prediction</td>
                <td className="px-4 py-3 text-sm">
                  <span className={`inline-flex items-center px-3 py-1 rounded-full text-sm font-medium ${
                    (result.prediction_binary || result.prediction) === 'Audio Buzz' || 
                    (result.prediction_binary || result.prediction) === 'Buzz' ||
                    (result.prediction_binary || result.prediction) === 'Severe Buzz'
                      ? 'bg-red-900/50 text-red-300 border border-red-700'
                      : 'bg-green-900/50 text-green-300 border border-green-700'
                  }`}>
                    {result.prediction_binary || result.prediction}
                  </span>
                </td>
              </tr>
              <tr className="hover:bg-gray-800">
                <td className="px-4 py-3 text-sm font-medium text-gray-300">AVG (excluding basic frequency)</td>
                <td className="px-4 py-3 text-sm text-gray-400">{result.mean?.toFixed(2) || 'N/A'} dB</td>
              </tr>
              <tr className="hover:bg-gray-800">
                <td className="px-4 py-3 text-sm font-medium text-gray-300">Standard Deviation</td>
                <td className="px-4 py-3 text-sm text-gray-400">{result.std?.toFixed(2) || 'N/A'} dB</td>
              </tr>
              <tr className="hover:bg-gray-800">
                <td className="px-4 py-3 text-sm font-medium text-gray-300">±1σ Interval</td>
                <td className="px-4 py-3 text-sm text-gray-400">{result.metrics?.sigma_interval || result.interval || 'N/A'} dB</td>
              </tr>
              <tr className="hover:bg-gray-800">
                <td className="px-4 py-3 text-sm font-medium text-gray-300">Strong count (&gt;-45 dB)</td>
                <td className="px-4 py-3 text-sm text-gray-400">{result.strong_count || result.strongCount || 'N/A'}</td>
              </tr>
              <tr className="hover:bg-gray-800">
                <td className="px-4 py-3 text-sm font-medium text-gray-300">Outliers (&gt;|1σ|)</td>
                <td className="px-4 py-3 text-sm text-gray-400">{(result.above_count || result.aboveCount || 0) + (result.below_count || result.belowCount || 0)}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default ResultsTable;
